import App from "../../App";
import { connect } from "react-redux";
import { fetchTranslationMap, fetchOrgs } from "../actions/rightsActions";

const mapStateToProps = (state) => ({
  isAuthenticated: state.user.isAuthenticated,
});

const mapDispatchToProps = (dispatch) => ({
  fetchTranslationMap: () => dispatch(fetchTranslationMap()),
  fetchOrgs: () => dispatch(fetchOrgs()),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
